import styled from 'styled-components';

export const DropdownArrowContainer = styled.div<{ isOpen: boolean; $cell?: boolean }>`
  position: absolute;
  right: ${props => props.$cell ? '10px' : '16px'};
  top: 50%;
  transform: translateY(-50%) rotate(${props => props.isOpen ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;
  pointer-events: none;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input<{ hasError: boolean; isOpen: boolean; disabled?: boolean; $cell?: boolean; $cellWithClear?: boolean }>`
  padding: 8px 12px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  width: 100%;
  padding-right: 40px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'text'};

  &:hover:not(:disabled) {
    border-color: #cbd5e0;
  }

  &:focus {
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }

  &:disabled {
    background-color: #f7fafc;
  }

  &::placeholder {
    color: #696969;
    font-style: italic;
  }

  ${props => props.$cell && `
    padding: 6px 30px 6px 10px;
    font-size: 13px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    color: #374151;

    &:hover:not(:disabled) {
      border-color: #d1d5db;
    }

    &:focus {
      border-color: #0090d3;
      box-shadow: 0 0 0 2px rgba(0, 144, 211, 0.12);
    }

    &:disabled {
      background-color: #f9fafb;
      color: #9ca3af;
    }

    &::placeholder {
      color: #9ca3af;
      font-style: normal;
    }
  `}

  ${props => props.$cell && props.$cellWithClear && `
    padding-right: 44px;
  `}

  ${props => props.hasError && `
    border: 1.5px solid #F87171;
    box-shadow: 0 0 3px #F87171;
  `}
`;

export const OptionsList = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9100;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: ${props => props.isOpen ? 'block' : 'none'};
  margin-top: 2px;
`;

export const OptionItem = styled.div<{ isHighlighted?: boolean; disabled?: boolean }>`
  padding: 12px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
  overflow: hidden;
  min-width: 0;
  
  &:hover {
    background-color: ${props => !props.disabled ? '#f8f9fa' : 'white'};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const OptionItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

export const OptionName = styled.span`
  font-weight: 500;
  color: #333;
`;

export const OptionDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
  font-size: 12px;
  color: #666;
  width: 100%;
  overflow: hidden;

  span {
    background-color: #f0f0f0;
    padding: 2px 6px;
    border-radius: 4px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
`;

export const NoOptionsMessage = styled.div`
  padding: 12px;
  text-align: center;
  color: #666;
  font-style: italic;
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  padding: 12px;
  background: none;
  border: none;
  border-top: 1px solid #f0f0f0;
  cursor: pointer;
  color: #3182ce;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #f8f9fa;
  }

  &:disabled {
    color: #999;
    cursor: not-allowed;
  }
`;

export const PriceTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
`;

export const PriceTag = styled.span`
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
`;

export const ClearButton = styled.button<{ $cell?: boolean }>`
  position: absolute;
  right: ${props => props.$cell ? '26px' : '40px'};
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }
`; 

export const InputDiv = styled.div`
  height: fit-content;
  position: relative;
`;

export const Label = styled.label<{ disabled?: boolean }>`
  font-size: 12px;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  transition: color 0.2s ease-in-out;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out;
  cursor: text;
  
  &:hover:not(:disabled) {
    border-color: #cbd5e0;
  }
  
  &:focus {
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }
  
  &:disabled {
    background-color: #f7fafc;
    cursor: not-allowed;
  }
  
  &::placeholder {
    color: #696969;
    font-style: italic;
  }
  
  &.clientToFreight{
    width: 90%;
  }
`;

/** Gatilho flat para uso dentro de células de tabela (ex.: composição). */
export const InputCell = styled(Input)`
  border-radius: 0;
  border: none;
  background-color: transparent;
  height: auto;
  min-height: 44px;
  padding: 12px 14px;

  &:hover:not(:disabled) {
    border-color: transparent;
  }

  &:focus {
    border-color: transparent;
    box-shadow: inset 0 0 0 1px #0090d3;
    background-color: #f9fafb;
  }

  &:disabled {
    background-color: #f3f4f6;
    color: #9ca3af;
  }

  &::placeholder {
    font-style: normal;
    color: #9ca3af;
  }
`;

export const SearchOptions = styled.ul`
  position: absolute;
  list-style: none;
  z-index: 9100;
  width: 100%;
  top: calc(100% + 2px);
  border-radius: 1rem;
  border: 1px solid #EBEBEB;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
  max-height: 10rem;
  overflow-y: auto;
  
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const Option = styled.li<{isSelected?:boolean}>`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  cursor: pointer;
  padding: .8rem 1rem;
  background-color: ${props => props.isSelected ? '#F4F4F4' : '#FFF'};
  border-bottom: 1px solid #EBEBEB;
  user-select: none;
  
  &:hover {
    background-color: #F4F4F4;
  }
`;

export const SelectedItemsContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SelectedItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #e3f2fd;
  border-radius: 4px;
  border: 1px solid #2196f3;
`;

export const SelectedItemText = styled.span`
  color: #1976d2;
  font-weight: 500;
`;

export const RemoveIcon = styled.div<{ disabled?: boolean }>`
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  color: ${props => props.disabled ? '#ccc' : '#dc3545'};
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9900;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
`;

export const ModalIcon = styled.div`
  margin-bottom: 16px;
  color: #F87171;
`;

export const ModalTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #303030;
  margin: 0 0 8px 0;
`;

export const ModalText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #696969;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const ErrorMessage = styled.div`
  padding: 12px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  margin-bottom: 16px;
  color: #dc2626;
  font-size: 14px;
`;

export const SuccessMessage = styled.div`
  padding: 12px;
  background-color: #ecfdf3;
  border: 1px solid #bbf7d0;
  border-radius: 4px;
  margin-bottom: 16px;
  color: #166534;
  font-size: 14px;
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const CancelButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #0090D3;
  background-color: #FFFFFF;
  color: #0090D3;
`;

export const DeleteButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 20px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #F87171;
  background-color: #F87171;
  color: #FFFFFF;
`;

export const OptionContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OptionLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CreateOptionStyle = styled.div`
  color: #007bff;
  font-style: italic;
`;

export const PantoneSwatch = styled.span<{ hex?: string }>`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background-color: ${props => props.hex ? (props.hex.startsWith('#') ? props.hex : `#${props.hex}`) : '#d1d5db'};
  border: 1px solid rgba(0,0,0,0.15);
  flex-shrink: 0;
  align-self: center;
`;
